const areShapesContentEqual = (a, b) => a.props === b.props && a.meta === b.meta;
export {
  areShapesContentEqual
};
//# sourceMappingURL=areShapesContentEqual.mjs.map
